
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import creditServices from '@/services/credit-services';
import { eventBus } from '@/main';
const numeral = require('numeral');
@Component({
    components: {
        Loading
    }
})
export default class Recharge extends Vue {
  @Prop({ default: null })
  private onRecharge!: boolean;
  private bankSelected = this.rechargeMethods.find(x => x.value === 8) || this.rechargeMethods[0];
  private isLoading = false;
  private requested = false;
  private amountRequested = 0;
  private rechargeModel = {
    rechargeValue: 0,
    bankId: (DATA.rechargeMethods.find(x => x.value === 8) || DATA.rechargeMethods[0] || { value: 8 }).value,
    tradeContent: ''
  };
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get rechargeMethods() {
    return DATA.rechargeMethods;
  }

  get qrLink() {
      const amount = this.requested ? this.amountRequested : (numeral(this.rechargeModel.rechargeValue).value() || 0);
      if (!this.bankSelected) return '';
      return `https://api.vietqr.io/image/${this.bankSelected.name}-${this.bankSelected.bankNumber}-X1lAHCn.jpg?addInfo=${this.userInfo.userCode}&accountName=${this.bankSelected.ownerName}&amount=${amount}`;
  }

  @Watch('onRecharge', { immediate: true, deep: true })
  private watchOnRecharge() {
    this.recharge();
  }

  private async created() {
    eventBus.$on(APP_CONFIG.eventBusAction.selectRechargeHistory, (item) => {
      this.amountRequested = item.amount;
      this.requested = true;
    });
  }

  private async onSelectBank(bankId: number) {
    this.bankSelected = this.rechargeMethods.find(x => x.value === bankId);
    this.rechargeModel.bankId = bankId;
  }
  
  private async recharge() {
    try {
      const isValid = await (this.$refs['observer'] as any).validate();
      if (isValid) {

        this.isLoading = true;

        const dataRequest = {
          Amount: numeral(this.rechargeModel.rechargeValue).value(),
          Method: this.rechargeModel.bankId, // Assuming 1 is the bank ID for Vietinbank
          UID: this.userInfo.userId,
          Username: this.userInfo.userName,
          TradeContent: this.rechargeModel.tradeContent
        };

        const result = await creditServices.submitRecharge(dataRequest);

        if (
          result &&
          result.status === 200 &&
          result.data.message === 'Success'
        ) {
          Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thành công!',
          });
          this.amountRequested = numeral(this.rechargeModel.rechargeValue).value();
          this.rechargeModel = {
            rechargeValue: 0,
            bankId: this.bankSelected ? this.bankSelected.value : 8,
            tradeContent: ''
          };
          eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
          this.requested = true;
        } else {
          Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Thông báo!',
            text: `Tạo lệnh nạp tiền thất bại! ${result.data.error}`,
          });
        }
        this.isLoading = false;
      }
    } catch {
      return false;
    }
  }
}
